import React, { Component, useContext } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import _ from 'lodash';
import numeral from 'numeral';
import filterFactory from 'react-bootstrap-table2-filter';
import { ProgressBar } from 'react-bootstrap';
import {
  collectColumnNames,
  defaultColumnMapper,
  determineInvoicePaymentAmounts,
  determineInvoicePaymentSum,
} from '../utils';
import { AuthContext } from '../components/Auth';
import PaymentTotal from '../components/PaymentTotal';
import PaymentModal from '../components/PaymentModal';
import PaymentCompleteModal from '../components/PaymentCompleteModal';
import NoInvoices from '../components/NoInvoices';
import Error from '../components/Error';
import { redirectToPayment } from '../utils/redirect';
import { fetchInvoices } from '../redux/modules/invoice';

const DEFAULT_BOUNCE_FEE_AMOUNT = 40;
const DEFAULT_CUSTOM_AMOUNT = 0;

export class InvoiceTable extends Component {
  state = {
    invoices: [],
    selected: [],
    confirmPayment: false,
    processingPayment: false,
    payment: {},
    loading: false,
    error: false,
    errorMessage: null,
    bounceFee: DEFAULT_CUSTOM_AMOUNT,
    customAmount: DEFAULT_CUSTOM_AMOUNT,
    customAmountCheck: false,
    customMessage: '',
  };

  componentWillMount() {
    this.setState({ loading: true, error: false, message: null });
    fetchInvoices()
      .then((invoices) => this.setState({ invoices, loading: false }))
      .catch(({ response, message }) =>
        this.setState({
          loading: false,
          error: true,
          errorMessage: _.get(response, 'data.message', message),
        }),
      );
  }

  selectRow = {
    mode: 'checkbox',
    style: { backgroundColor: '#d8cdcd' },
    clickToSelect: true,
    onSelect: (row, isSelect) => {
      this.setState((state) => ({
        selected: isSelect
          ? [...state.selected, row.contract]
          : state.selected.filter((contract) => contract !== row.contract),
      }));
    },
    onSelectAll: (isSelect, rows) => {
      this.setState((state) => ({
        selected: isSelect ? [...state.selected, ..._.map(rows, 'contract')] : [],
      }));
    },
  };
  defaultSorted = [
    {
      dataField: 'dateOfSale',
      order: 'desc',
    },
  ];

  handlePaymentSubmit = () => {
    this.setState({ processingPayment: true });
    const { invoices, selected, bounceFee, customAmount, customMessage } = this.state;
    const amounts = determineInvoicePaymentAmounts(invoices, selected);
    const sum = determineInvoicePaymentSum(invoices, selected) + bounceFee + customAmount;
    const comments = `${bounceFee ? `$${DEFAULT_BOUNCE_FEE_AMOUNT} NSF fee applied. ` : ''}${
      customAmount ? customMessage || `$${sum} Custom fee applied.` : ''
    }`;
    const payload = {
      contractNumbers: selected,
      amounts,
      sum: numeral(sum).format('0.00'),
      comments,
      customComment: String(!!customMessage),
      nsfComment: String(!!bounceFee),
      // NOTE - This is specific to ASN logins.
      forwardTokenParams: this.props.tokenParams,
    };

    this.setState({ processingPayment: false, confirmPayment: false, payment: payload });
    setTimeout(_.partial(redirectToPayment, payload), 1000);
  };

  handlePaymentClick = (toggle) => {
    this.setState({ confirmPayment: toggle });
  };

  handlePaymentResultsDismiss = () => {
    this.setState({ payment: {} });
  };

  handleBounceFee = (value) => {
    this.setState({ bounceFee: value ? DEFAULT_BOUNCE_FEE_AMOUNT : DEFAULT_CUSTOM_AMOUNT });
  };

  handleCustomAmount = (value) => {
    this.setState({ customAmount: value ? parseFloat(value) : DEFAULT_CUSTOM_AMOUNT });
  };

  handleCustomAmountCheck = (value) => {
    this.setState({ customAmountCheck: value, customAmount: DEFAULT_CUSTOM_AMOUNT });
  };

  handleCustomMessageChange = (value) => {
    this.setState({ customMessage: value });
  };

  render() {
    const {
      invoices,
      selected,
      confirmPayment,
      processingPayment,
      payment,
      loading,
      error,
      errorMessage,
      bounceFee,
      customAmount,
      customAmountCheck,
      customMessage,
    } = this.state;
    const cols = collectColumnNames(invoices);
    const sum = determineInvoicePaymentSum(invoices, selected) + bounceFee + customAmount;

    return (
      <div className="container-fluid">
        {loading && (
          <ProgressBar
            active
            striped
            style={{ width: '80%', margin: 'auto', marginTop: 50, marginBottom: 20 }}
            label="Loading invoices.."
            now={100}
          />
        )}
        {this.state.invoices.length > 0 && (
          <div className="row">
            <div className="col-xs-12">
              <h5>Select Items for Payment</h5>
            </div>
            <div className="col-xs-12">
              <BootstrapTable
                keyField="contract"
                hover
                striped
                condensed
                rowStyle={{ cursor: 'pointer' }}
                data={invoices}
                columns={_.map(cols, defaultColumnMapper)}
                selectRow={{
                  ...this.selectRow,
                  selected,
                }}
                defaultSorted={this.defaultSorted}
                filter={filterFactory()}
                {...this.props}
              />
            </div>
          </div>
        )}
        {this.state.invoices.length < 1 && !loading && !error && <NoInvoices />}
        {error && <Error message={errorMessage} />}

        <PaymentModal
          show={confirmPayment}
          processing={processingPayment}
          invoices={invoices.filter(({ contract }) => _.includes(selected, contract))}
          sum={sum}
          onSubmit={this.handlePaymentSubmit}
          onCancel={() => this.handlePaymentClick(false)}
          handleBounceFee={this.handleBounceFee}
          bounceFee={bounceFee}
          handleCustomAmount={this.handleCustomAmount}
          handleCustomAmountCheck={this.handleCustomAmountCheck}
          customAmount={customAmount}
          customAmountCheck={customAmountCheck}
          handleCustomMessageChange={this.handleCustomMessageChange}
          customMessage={customMessage}
        />
        <PaymentCompleteModal
          {...payment}
          show={!_.isEmpty(payment)}
          onClick={this.handlePaymentResultsDismiss}
        />

        <PaymentTotal sum={sum} onClick={() => this.handlePaymentClick(true)} />
      </div>
    );
  }
}

export default function InvoiceTableFunctionalWrap(props) {
  const { tokenParams } = useContext(AuthContext);
  return <InvoiceTable {...props} tokenParams={tokenParams} />;
}



// WEBPACK FOOTER //
// ./src/containers/InvoiceTable.js